import { render } from "./Mob-Help.view.vue?vue&type=template&id=04ff863c"
import script from "./Mob-Help.view.vue?vue&type=script&lang=js"
export * from "./Mob-Help.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__